import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'kendo-custom-date-picker-ampm',
    templateUrl: './kendo-custom-date-picker-ampm.component.html',
})
export class KendoCustomDatePickerAMPMComponent {
    @Input() labelText = '';
    @Input() isValid = true;
    @Input() isDatePickerDisabled = false;
    @Input() displayTimePicker = true;
    @Input() boundaryDate: Date | undefined;

    @Input() isFromVV = true;
    @Input() isStartTime = true;
    @Input() date: Date | undefined;
    @Output() dateChange: EventEmitter<Date> = new EventEmitter();

    @Input() isAMCheckboxDisabled = false;
    @Input() isPMCheckboxDisabled = false;
    @Input() checkBoxAM = false;
    @Input() checkBoxPM = false;
    @Input() checkBoxAMText = 'AM';
    @Input() checkBoxPMText = 'PM';
    @Input() inValidMsg = '';

    @Input() inputClass: any = {};

    @Output() checkBoxAMChange: EventEmitter<boolean> = new EventEmitter();
    @Output() checkBoxPMChange: EventEmitter<boolean> = new EventEmitter();
    @Output() isValidChange: EventEmitter<boolean> = new EventEmitter();

    get dateIsValid(): boolean {
        return (
            this.isValid &&
            this.date! <= this.maxDate &&
            this.date! >= this.minDate
        );
    }

    get minDate(): Date {
        const defaultDate = new Date(1900, 0, 1);
        return this.isFromVV && !!this.boundaryDate
            ? this.boundaryDate
            : defaultDate;
    }

    get maxDate(): Date {
        const defaultDate = new Date(2300, 0, 1);
        return !this.isFromVV && !!this.boundaryDate
            ? this.boundaryDate
            : defaultDate;
    }

    onDateChange() {
        this.dateChange.emit(this.date);
        this.isValidChange.emit(this.dateIsValid);
    }

    onAMChange() {
        this.checkBoxAMChange.emit(this.checkBoxAM);
    }

    onPMChange() {
        this.checkBoxPMChange.emit(this.checkBoxPM);
    }
}
